import type {
  AddContractBonusPayload,
  CompanyResults,
  ContractBonus,
} from "@/types/reports";
import { apiClient } from "./client";

export const reportsApi = {
  /** Without a month the results cover the whole year. */
  getCompanyResults(year: number, month: number | null) {
    const query =
      month === null ? `year=${year}` : `year=${year}&month=${month}`;
    return apiClient.get<CompanyResults>(
      `/api/reports/company-results?${query}`,
    );
  },

  addContractBonus(payload: AddContractBonusPayload) {
    return apiClient.post<ContractBonus>(
      "/api/reports/contract-bonuses",
      payload,
    );
  },

  deleteContractBonus(id: string) {
    return apiClient.delete<void>(`/api/reports/contract-bonuses/${id}`);
  },
};
